import { render, staticRenderFns } from "./votedata.vue?vue&type=template&id=295f7c82&scoped=true&"
import script from "./votedata.vue?vue&type=script&lang=js&"
export * from "./votedata.vue?vue&type=script&lang=js&"
import style0 from "./votedata.vue?vue&type=style&index=0&id=295f7c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f7c82",
  null
  
)

export default component.exports